import { ref, onMounted, onUnmounted } from "vue";

export function useIdle(durationSeconds = 7200) {
  const isIdle = ref(false);
  let timer;

  const resetTimer = () => {
    clearTimeout(timer);
    isIdle.value = false;
    timer = setTimeout(() => {
      isIdle.value = true;
    }, durationSeconds * 1000);
  };

  const events = ["mousemove", "keydown", "wheel", "touchstart"];

  onMounted(() => {
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
  });

  onUnmounted(() => {
    events.forEach((event) => window.removeEventListener(event, resetTimer));
    clearTimeout(timer);
  });

  return { isIdle };
}
